import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(() => ({
  root: {
    minWidth: 0
  }
}));

export default withCustomStyles;
